import "./project-modal.js";

// WordPress customizer preview refresh
if (typeof wp !== "undefined" && wp.customize) {
  wp.customize("blogname", function (value) {
    value.bind(function (newval) {
      document.querySelector(".site-title").textContent = newval;
    });
  });

  wp.customize("blogdescription", function (value) {
    value.bind(function (newval) {
      document.querySelector(".site-description").textContent = newval;
    });
  });
}
